import moment from 'moment';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Modal, DatePicker } from 'antd';
import _StudentService from '../../modules/StudentService';
import _authService from '../../modules/AuthService';
import _notification from '../../modules/notification';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import WizardSteps from 'components/enterprise/WizardSteps';
// Phase C.7.4D (§8 Candidate/Application Identity Card): reuses the exact same Card +
// .ent-identity-grid/.ent-field-label/.ent-identity-value pattern C.7.3 already built for the
// authenticated dashboard's own identity card — same data shape (Name/Form Number/Applied For/DOB/
// Mobile Number), same visual language, no new component invented.
import Card from 'components/enterprise/Card';
// Phase C.5 (Candidate System UI Language Migration): moved off the legacy modules/i18n.js
// hardcoded-English+Marathi dictionary onto the centralized Text/dictionary.js architecture — see
// modules/i18n/dictionary.js's navigationTab namespace. tr() mirrors Registration_new.jsx's/
// NewLogin.jsx's identical helper — plain resolveText() for string-context uses (Modal title,
// DatePicker placeholder, setState error strings) that can't take the <Text> element directly.
import Text, { resolveText } from 'components/Text/Text';
import { getCurrentLocale, getCurrentDisplayMode } from 'modules/LanguageContext';

function tr(key) {
    return resolveText(key, getCurrentLocale(), getCurrentDisplayMode());
}

const NavigationTab_new_one = (props) => {
    const [data, setData] = useState({});
    const [updateDOBModalFlag, setUpdateDOBModalFlag] = useState(false);
    const [Birth_Date, setBirth_Date] = useState(null);
    const [Birth_DateError, setBirth_DateError] = useState("")

    useEffect(() => {
        getStudentPersonalData()
    }, [])

    const getStudentPersonalData = async () => {
        try {
            let response = await _StudentService.getStudentPersonalInfo();
            //console.log("MMR: ", response.data);
            setData(response.data);
        } catch (e) { }
    }


    const updateDOBModal = () => {
        setUpdateDOBModalFlag(true)
      };
    
      const handleUpdateDOBModalOk = async () => {
        // 

        let hasError = false;

        if (!Birth_Date) {
            setBirth_DateError(tr('navigationTab.enterValidBirthDateError'))
            hasError = true
        }

        if (moment(Birth_Date).isValid() && moment(Birth_Date).isSameOrAfter(moment(), 'day')) {
            setBirth_DateError(tr('navigationTab.enterValidBirthDateError'))
            hasError = true
        }

        if(!hasError){
            

            let body = {};
            body.Birth_Date = Birth_Date;

            const response = await _authService.UPDATESTUDENTDATEOFBIRTH(body);

            if (response.data.Message === "Candidate Data Updated successfully!") {
                setBirth_DateError("")
                setUpdateDOBModalFlag(false)
                getStudentPersonalData()
                setBirth_Date(null)
                _notification.showMessage('success', 'Candidate Data Updated successfully!');
            }

            
        }
        else{
            setBirth_DateError(tr('navigationTab.enterValidBirthDateError'))
        }

      };
    
      const handleUpdateDOBModalCancel = e => {
        console.log(e);
        setUpdateDOBModalFlag(false)
        setBirth_DateError("")
      };


      const onDateChange = (date, dateString) => {
        setBirth_Date(date ? date : null)
    };

    if (data) {
        // Phase C.7.4D (§8 Candidate/Application Identity Card): consolidates the previous
        // `.navigation-private`/`.np-row`/`.np-field-wrap` inline-style-heavy markup (heavy 4px
        // colored bottom border, forced bold-700 teal values, an "Applied For:Clerk" pair with no
        // space between label and value) into the same compact identity-grid pattern already
        // established for the dashboard's own identity card (C.7.3). Every field/value below reads
        // from the exact same `data` state (getStudentPersonalInfo(), unchanged) — no new API call,
        // no field added or removed.
        const fullName = [data.First_Name, data.Middle_Name, data.Last_Name].filter(Boolean).join(' ');
        return (
            <>
                {props.currentStep !== undefined && <WizardSteps current={props.currentStep} />}

                <Card className="ent-identity-summary-card">
                    <div className="ent-identity-grid">
                        <div className="ent-identity-cell">
                            <div className="ent-field-label"><Text k="navigationTab.nameLabel" /></div>
                            <div className="ent-identity-value ent-identity-value-primary" style={{ textTransform: 'capitalize' }}>{fullName || 'N/A'}</div>
                        </div>
                        <div className="ent-identity-cell">
                            <div className="ent-field-label"><Text k="navigationTab.formNumberLabel" /></div>
                            <div className="ent-identity-value">{data.Form_Number || 'N/A'}</div>
                        </div>
                        <div className="ent-identity-cell">
                            <div className="ent-field-label"><Text k="navigationTab.appliedForLabel" /></div>
                            <div className="ent-identity-value">{data.Applied_Post || 'N/A'}</div>
                        </div>
                        <div className="ent-identity-cell">
                            <div className="ent-field-label"><Text k="navigationTab.dobLabel" /></div>
                            <div className="ent-identity-value">{data.Birth_Date ? (moment(data.Birth_Date).format('DD-MMMM-YYYY')) : 'N/A'}</div>
                        </div>
                        <div className="ent-identity-cell">
                            <div className="ent-field-label"><Text k="navigationTab.mobileNumberLabel" /></div>
                            <div className="ent-identity-value">{data.Mobile_Number || 'N/A'}</div>
                        </div>
                    </div>
                </Card>
                <Modal
                    title={tr('navigationTab.updateDobModalTitle')}
                    visible={updateDOBModalFlag}
                    onOk={handleUpdateDOBModalOk}
                    onCancel={handleUpdateDOBModalCancel}
                    okText="Update"
                    okButtonProps={{style: { height:"32px" }}}
                >
                    <div>
                                {/* Phase C.7.4D-R1 (§4): ent-required-asterisk — zero gap after label text. */}
                                <label className="card-holder-name mb0"><Text k="navigationTab.dateOfBirthLabel" /><span className="color-red ent-required-asterisk">*</span></label>
                                </div>
                                <div>
                                <DatePicker
                                    className={Birth_DateError ? "has-error mt7" : 'mt7'}
                                    style={{ width: "300px" }}
                                    onChange={onDateChange} format="DD-MMM-YYYY"
                                    value={Birth_Date === null ? Birth_Date : moment(Birth_Date).isValid() ? moment(Birth_Date) : null}
                                    placeholder={tr('navigationTab.selectBirthDatePlaceholder')} />
                                {Birth_DateError && <label className="color-red d-block">{Birth_DateError}</label>}
                            </div>
                </Modal>
            </>
        );
    }
    else {
        return <LoadingSpinner />
    }
};

export default NavigationTab_new_one;